import LocationObject from 'entities/locationObject/model';
import config from 'config';
import { validateLocationObject } from 'utils/validateLocationObject';

import { mapResponse } from './mapResponse';
import { validateResponse } from './validateResponse';

export const validateAndMapAddress = async (
  address: string,
  countryCode: string
): Promise<string | LocationObject> => {
  const response = await fetch(
    `https://addressvalidation.googleapis.com/v1:validateAddress?key=${config.googleMapsApiKey}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        address: {
          addressLines: [address],
          regionCode: countryCode,
        },
      }),
    }
  );

  if (!response.ok) {
    throw new Error('Network error');
  }

  const data = await response.json();

  validateResponse(data);

  const locationObject = mapResponse(data, countryCode);
  validateLocationObject(locationObject);
  return locationObject;
};
